import {
  GET_BUNDLES,
  UPDATE_BUNDLE_STATUS,
  GET_BUNDLE_WITH_ID,
  CANCEL_BUNDLE,
  GET_LOGS,
  GET_ALL_BUNDLES, CLEAR_BUNDLE,UPDATE_BUNDLE
} from './constants';
import { Payload, cancelPayload } from './interfaces';

export function getBundlesAction(payload: Object) {
  return {
    type: GET_BUNDLES,
    payload,
  };
}

export function getAllBundlesAction(payload: Object) {
  return {
    type: GET_ALL_BUNDLES,
    payload,
  };
}

export function getBundleWithIdAction(payload: { id: number }) {
  return {
    type: GET_BUNDLE_WITH_ID,
    payload,
  };
}

export function updateBundleStatusActions(payload: Payload) {
  return {
    type: UPDATE_BUNDLE_STATUS,
    payload,
  };
}
export function updateBundleActions(payload: Payload) {
  return {
    type: UPDATE_BUNDLE,
    payload,
  };
}

export function cancelBundleActions(payload: cancelPayload) {
  return {
    type: CANCEL_BUNDLE,
    payload,
  };
}

export function getLogsAction(payload: { id: number }) {
  return {
    type: GET_LOGS,
    payload,
  };
}

export function clearBundleAction() {
  return{
    type: CLEAR_BUNDLE
  }
}
